"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var gridControl = function gridControl(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "grid-control"
  }, children);
};

var _default = gridControl;
exports.default = _default;